import { createEvent, createStore } from 'effector';
import { effectorStartEvent } from '@nx-frontend/shared/store/client-side';
import { PortalSearchParams } from '@nx-frontend/shared/types';

export enum AppMode {
  PORTAL = 'portal',
  CUSTOMIZER = 'customizer',
}

export interface AppState {
  mode: AppMode;
  orgId: string;
  workspaceId: string;
  portalId: string;
  sessionId: string | null;
  host: string;
  path: string;
  searchParams: PortalSearchParams;
  popupActive: boolean;
  sectionRoot: string;
  chatBundleJsUrl?: string;
  tasksBundleJsUrl?: string;
  bundlesCssUrl?: string;
  urlPath?: string;
}

export const initialAppState: AppState = {
  mode: AppMode.PORTAL,
  orgId: '',
  workspaceId: '',
  portalId: '',
  sessionId: null,
  host: '',
  path: '',
  sectionRoot: '',
  searchParams: {},
  popupActive: false,
  urlPath: '',
};

export const setPopupActiveEvent = createEvent<boolean>();

export const $app = createStore(initialAppState)
  .on(effectorStartEvent, (state) => state)
  .on(setPopupActiveEvent, (state, status) => {
    return { ...state, popupActive: status };
  });

export const $sessionId = $app.map((state) => state.sessionId);
export const $host = $app.map((state) => state.host);
export const $path = $app.map((state) => state.path);
export const $urlPath = $app.map((state) => state.urlPath);
export const $searchParams = $app.map((state) => state.searchParams);
export const $popupActive = $app.map((state) => state.popupActive);
export const $orgId = $app.map((state) => state.orgId);
export const $workspaceId = $app.map((state) => state.workspaceId);
export const $portalId = $app.map((state) => state.portalId);
export const $sectionRoot = $app.map((state) => state.sectionRoot);
export const $portalsMode = $app.map((state) => state.mode);
export const $isPortalMode = $portalsMode.map((mode) => mode === AppMode.PORTAL);
export const $isCustomizerMode = $portalsMode.map((mode) => mode === AppMode.CUSTOMIZER);
export const $chatBundleJsUrl = $app.map((state) => state.chatBundleJsUrl);
export const $tasksBundleJsUrl = $app.map((state) => state.tasksBundleJsUrl);
export const $bundlesCssUrl = $app.map((state) => state.bundlesCssUrl);
